// Student v2 header: logo, optional env-gated coin control, alarm, profile, app install banner.
import React from "react";
import { Link } from "react-router-dom";
import AlarmTooltipContainer from "./AlarmTooltip.container";
import InstallAppBannerContainer from "commons/banner/InstallAppBanner.container";

const HeaderComponent = ({ ...props }) => {
    const {
        userInfo,
        showAlarmTooltip,
        onAlarmClick,
        onCloseAlarmTooltip,
        unreadCount,
        showCoinButton = false,
        coinBalance,
        isCoinLoading,
        onCoinClick,
    } = props;

    const formatCoinBalance = (balance: number) => {
        if (balance >= 1000000000) {
            return (balance / 1000000000).toFixed(2) + 'b';
        } else if (balance >= 1000000) {
            return (balance / 1000000).toFixed(2) + 'm';
        } else if (balance >= 1000) {
            return (balance / 1000).toFixed(2) + 'k';
        } else {
            return balance.toString();
        }
    };

    const profileSrc = (() => {
        const src = userInfo?.profileImage;
        if (!src) return "/imgs/dummy/basic-img.png";
        // Don't append query params to data URLs or blob URLs.
        if (typeof src === "string" && (src.startsWith("data:") || src.startsWith("blob:"))) return src;
        return `${src}?w=80`;
    })();

    return (
        <header className="fixed top-0 left-0 right-0 w-full bg-white shadow z-50 pt-[env(safe-area-inset-top)]">
            <div className="max-w-7xl mx-auto px-4">
                <div className="py-2 flex justify-between items-center">
                    <Link to="/student" className="inline-block">
                        <img
                            src="./imgs/common/logo/img-logo/logo-t2-125.png"
                            alt="wannabes"
                            className="w-[40px] md:w-[35px] sm:w-[25px]"
                        />
                    </Link>

                    <div className="flex items-center gap-4">
                        {showCoinButton ? (
                            <button
                                onClick={onCoinClick}
                                className="relative flex items-center justify-center text-gray-700 hover:opacity-80 transition-opacity cursor-pointer"
                            >
                                <img
                                    src="./imgs/icons/icon-diamond.svg"
                                    alt="코인"
                                    className="w-6 h-6 sm:w-5 sm:h-5"
                                />
                                <span
                                    className="absolute bottom-0 text-[9px] font-medium sm:text-[8px] leading-none whitespace-nowrap bg-white/70 px-0.5 rounded"
                                    style={{ transform: "translateY(50%)" }}
                                >
                                    {isCoinLoading ? "..." : formatCoinBalance(coinBalance || 0)}
                                </span>
                            </button>
                        ) : null}
                        <button onClick={onAlarmClick} className="text-gray-600 hover:text-gray-900 relative">
                            <img src="./imgs/icons/alarm-icon.png" alt="알림" className="w-7 h-7 sm:w-5 sm:h-5" />
                            {unreadCount > 0 && (
                                <div className="absolute -top-1 -right-1 w-2.5 h-2.5 bg-red-500 rounded-full animate-pulse"></div>
                            )}
                        </button>
                        {showAlarmTooltip && (
                            <AlarmTooltipContainer onClose={onCloseAlarmTooltip} />
                        )}
                        <Link to="/student/my" className="text-gray-600 hover:text-gray-900">
                            <img
                                src={profileSrc}
                                alt={userInfo?.nickname}
                                className="w-[40px] h-[40px] md:w-[35px] md:h-[35px] sm:w-[25px] sm:h-[25px] rounded-full object-cover"
                                onError={(e) => {
                                    e.currentTarget.src = "/imgs/dummy/basic-img.png";
                                }}
                            />
                        </Link>
                    </div>
                </div>
            </div>
            {/* 모바일 웹에서 앱 설치 유도 배너 */}
            <InstallAppBannerContainer />
        </header>
    );
};

export default HeaderComponent;